import { Fragment } from 'react';

import { IconRadioChecked } from '@components/icons/radio-checked';
import { IconRadioIdle } from '@components/icons/radio-idle';
import { TextField } from '@components/text-field';

import type { MenuProps } from './types';

import { FilterActionButtons } from '../actions-buttons';
import { FilterComparer } from '../common';
import { useFilterTranslate } from '../filter-utils';
import { FilterListItem } from '../list-item';

const DEFAULT_TEXT_COMPARERS = [
  'is',
  'not_is',
  'starts',
  'not_starts',
  'contains',
  'not_contains',
] satisfies Array<FilterComparer>;

export const TextMenu = ({ state, actions, config }: MenuProps) => {
  const { t } = useFilterTranslate();
  const comparers =
    ('allowedComparers' in config && config.allowedComparers) || DEFAULT_TEXT_COMPARERS;

  return (
    <Fragment>
      {comparers.map((comparer) => {
        const isCurrentComparer = state.comparer === comparer;
        const label = t(`core.comparator.${comparer}`) || comparer;

        return (
          <Fragment key={comparer}>
            <FilterListItem
              icon={isCurrentComparer ? <IconRadioChecked /> : <IconRadioIdle />}
              label={label.replace('...', '')}
              onClick={() => {
                actions.selectComparer(comparer);
                if (state.value) {
                  actions.selectValue(state.value);
                }
              }}
            />
            {isCurrentComparer && (
              <TextField
                autoFocus
                onChange={actions.selectValue}
                value={(state.value as string) || ''}
                label={label}
                hideLabel
              />
            )}
          </Fragment>
        );
      })}
      <FilterActionButtons state={state} actions={actions} disableApply={!state.value} />
    </Fragment>
  );
};
